import { classNames } from "@greeter/util";
import css from "./BundleFormSummary.module.scss";
import { sumAdditionalPriceVariant } from "@greeter/core";
import { BundleForm } from "./models";

export function BundleFormSummary(props: { bundle: BundleForm }) {
  return (
    <div className={css.Summary}>
      {props.bundle.lines.map((l) => {
        return (
          <div className={css.BundleLine}>
            <span className={css.LineTitle}>{l.name}</span>
            <div className={css.VariantTitles}>
              {l.variants
                .filter(
                  (v) =>
                    (v.quantity ?? 0) > 0 ||
                    (l.extra.find((e) => e.bundleLineVariantId === v.id)
                      ?.quantity ??
                      0 > 0)
                )
                .map((v) => {
                  const sumAdditional = sumAdditionalPriceVariant(v);
                  const extra = l.extra.find(
                    (e) => e.bundleLineVariantId === v.id
                  );
                  const sumExtra = (extra?.quantity ?? 0) * v.salesPrice;

                  return (
                    <>
                      {(v.quantity ?? 0) > 0 && (
                        <span {...classNames(css.VariantTitle)}>
                          {v.quantity} x {v.name}
                          {sumAdditional > 0 ? (
                            <span
                              className={css.ChangeText}
                              style={{ marginLeft: 5 }}
                            >
                              (+{sumAdditional} kr.)
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      )}

                      {extra && sumExtra > 0 && (
                        <span {...classNames(css.VariantTitle, css.ChangeText)}>
                          {extra.quantity} x {v.name}
                          <span
                            className={css.ChangeText}
                            style={{ marginLeft: 5 }}
                          >
                            (+{sumExtra} kr.)
                          </span>
                        </span>
                      )}
                    </>
                  );
                })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
